<svelte:options tag="legal-accordion" />

<div id="main" class="legalstuff">
  <span class="pagetitle">Legal Information</span>
  <div class="pageinfo">
    Below you will find all our legal documentation. Click though items below to visit individual policies and
    information.
  </div>
  {#if mydata.length}
    {#each mydata as { open, id, content, title, subpages }}
      <button class:active={open} class="accordion" on:click={() => (open = !open)}>
        <span class="heading">
          {#if id === 'copyright-statement'}
            <span class="svgwrap">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="copyright"
                class="svg-inline--fa fa-copyright fa-w-16"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                ><path
                  fill="#401E12"
                  d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm216 248c0 118.663-96.055 216-216 216-118.663 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.663 0 216 96.055 216 216zM360.474 357.366c-9.414 9.142-44.455 38.966-100.106 38.966-77.825 0-136.513-60.551-136.513-140.846 0-77.951 58.345-137.596 135.431-137.596 53.547 0 85.508 24.785 94.028 32.381a11.96 11.96 0 0 1 1.721 16.001l-8.763 12.08c-4.034 5.561-11.877 6.579-17.203 2.329-8.921-7.122-33.509-23.688-69.062-23.688-54.32 0-94.161 41.791-94.161 98.131 0 58.209 40.791 102.104 94.882 102.104 39.538 0 66.522-22.074 73.851-28.84 5.068-4.681 13.054-4.108 17.423 1.239l9.414 11.534c3.969 4.861 3.564 11.828-.942 16.205z"
                /></svg
              >
            </span>
          {:else if id === 'ripe-ncc-privacy-statement'}
            <span class="svgwrap">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="user-secret"
                class="svg-inline--fa fa-user-secret fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                ><path
                  fill="#401E12"
                  d="M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-43.2c1.5-7.8 2.4-15.8 2.4-24 0-7.2-.9-14.2-2.2-21.1 40.5-9.8 66.2-24.2 66.2-40.2 0-16.5-27-31.2-69.3-41-8.9-33.6-27.4-67.9-41.3-85.4-6.3-8-15.7-12.3-25.3-12.3-9.5 0-12.3 2.4-41.8 17.2-12.8 6.4-24.3 2.1-28.6 0C179.9 2.3 177.3 0 167.9 0c-9.6 0-18.9 4.3-25.2 12.2-13.9 17.5-32.4 51.8-41.3 85.4C59 107.4 32 122.2 32 138.7c0 16.1 25.7 30.5 66.2 40.2-1.3 6.9-2.2 13.9-2.2 21.1 0 8.2.9 16.2 2.4 24H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM128 200c0-2.7.3-5.3.6-7.9 1.3.8 5.1 3.3 5.8 5.4 3.9 11.9 7 24.6 16.5 33.4 8 7.4 47 25.1 64-25 2.8-8.4 15.4-8.4 18.3 0 16 47.4 53.9 34.4 64 25 9.5-8.8 12.7-21.5 16.5-33.4.7-2.1 4.4-4.6 5.8-5.4.3 2.6.6 5.2.6 7.9 0 52.9-43.1 96-96 96S128 252.9 128 200zm-.7-75.5c.7-2.7 12.3-57 40.5-92.5 28.7 14.4 37.7 20.5 56.2 20.5 18.6 0 27.7-6.3 56.2-20.5l.1.1c28.1 35.4 39.7 89.6 40.4 92.4 21.4 4.9 35.8 7.9 51 14.2-24.3 9.9-75.4 21.3-147.7 21.3s-123.4-11.4-147.7-21.3c15.2-6.3 29.9-9.3 51-14.2zM44.8 480c-7.1 0-12.8-5.7-12.8-12.8v-44.8c0-36.5 19.2-69.5 51.4-88.2L108 320l-27.4-64h28.9c4.7 9.6 64.3 108.5 64.3 108.5L142.9 480H44.8zm131.2 0l32-120-21.9-38.4c12.1 3.8 24.6 6.4 37.9 6.4s25.9-2.6 37.9-6.4L240 360l32 120h-96zm240-12.8c0 7.1-5.7 12.8-12.8 12.8h-98.1l-30.8-115.5s59.6-98.9 64.3-108.5h31l-25 65.6 22.5 13.9c30.6 18.9 48.9 51.4 48.9 86.9v44.8z"
                /></svg
              >
            </span>
          {:else if id.includes('terms')}
            <span class="svgwrap">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="scroll"
                class="svg-inline--fa fa-scroll fa-w-20"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
                ><path
                  fill="#401E12"
                  d="M608 352h-64V112C544 50.25 493.75 0 432 0H80C35.88 0 0 35.89 0 80v80c0 17.64 14.34 32 32 32h96v224c0 51.11 40.25 92.62 90.66 95.46v.54h312C590.94 512 640 462.95 640 402.67V384c0-17.64-14.34-32-32-32zM128 160H32V80c0-26.47 21.53-48 48-48s48 21.53 48 48v80zm160 256c0 35.3-28.72 64-64 64s-64-28.7-64-64V80c0-18-5.97-34.62-16.03-48H432c44.12 0 80 35.89 80 80v240H320c-17.66 0-32 14.36-32 32v32zm320-13.33c0 42.64-34.69 77.33-77.34 77.33H295.03c15.35-17.02 24.97-39.32 24.97-64v-32h288v18.67z"
                /></svg
              >
            </span>
          {:else if id === 'cookies'}
            <span class="svgwrap">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="cookie"
                class="svg-inline--fa fa-cookie fa-w-16"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                ><path
                  fill="#401E12"
                  d="M352 328c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-8-200c0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24zm-160 64c0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24zm8 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96-96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm222.37 22.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15C250.11.54 243.22 0 236.34 0c-20.72 0-41.25 4.88-59.89 14.38l-69.12 35.21a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.87A132.602 132.602 0 0 0 1.62 257.2l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c6.86 1.09 13.75 1.62 20.63 1.62 20.72 0 41.25-4.88 59.88-14.38l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87a132.56 132.56 0 0 0 12.82-80.93zm-41.33 66.41l-35.1 68.88c-9.68 19-24.83 34.15-43.8 43.82l-69.12 35.21c-13.98 7.13-29.67 10.89-45.36 10.89-5.21 0-10.47-.41-15.63-1.23l-76.69-12.14c-20.99-3.33-40.04-13.04-55.09-28.08L73.5 383.79c-15.09-15.09-24.84-34.22-28.18-55.33L33.24 252.2c-3.35-21.12.02-42.36 9.72-61.4l35.1-68.88c9.68-19 24.83-34.15 43.8-43.82l69.12-35.21C204.97 35.77 220.65 32 236.34 32c5.21 0 10.47.41 15.62 1.23l76.7 12.15c20.99 3.32 40.04 13.03 55.08 28.08l54.76 54.75c15.09 15.09 24.84 34.22 28.18 55.33l12.08 76.26c3.35 21.12-.02 42.36-9.72 61.4z"
                /></svg
              >
            </span>
          {:else if id === 'legal'}
            <span class="svgwrap">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="balance-scale-right"
                class="svg-inline--fa fa-balance-scale-right fa-w-20"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
                ><path
                  fill="#401E12"
                  d="M634.4 375.09L525.35 199.12c-3.17-4.75-8.26-7.12-13.35-7.12s-10.18 2.38-13.35 7.12L389.6 375.09c-3.87 5.78-6.09 12.72-5.51 19.64C389.56 460.4 444.74 512 512 512c67.27 0 122.45-51.6 127.91-117.27.57-6.92-1.64-13.86-5.51-19.64zM511.96 238.24L602.27 384H421.02l90.94-145.76zM512 480c-41.28 0-77-26.77-90.42-64h181.2c-13.23 36.87-49.2 64-90.78 64zm17.89-317.21l5.08-15.17c1.4-4.19-.86-8.72-5.05-10.12L379.46 87.15C382.33 79.98 384 72.21 384 64c0-35.35-28.65-64-64-64-29.32 0-53.77 19.83-61.34 46.73L120.24.42c-4.19-1.4-8.72.86-10.12 5.05l-5.08 15.17c-1.4 4.19.86 8.72 5.05 10.12l148.29 49.62c5.91 22.23 23.33 39.58 45.62 45.36V480H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h224c4.42 0 8-3.58 8-8V125.74c8.64-2.24 16.5-6.22 23.32-11.58l160.45 53.68c4.18 1.4 8.71-.86 10.12-5.05zM320 96c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm-64.09 170.73c.58-6.92-1.64-13.86-5.51-19.64L141.35 71.12C138.18 66.38 133.09 64 128 64s-10.18 2.38-13.35 7.12L5.6 247.09c-3.87 5.78-6.09 12.72-5.51 19.64C5.56 332.4 60.74 384 128 384s122.44-51.6 127.91-117.27zM127.96 110.24L218.27 256H37.02l90.94-145.76zM37.58 288h181.2c-13.23 36.87-49.2 64-90.78 64-41.28 0-77-26.77-90.42-64z"
                /></svg
              >
            </span>
          {/if}
          <span class="button-title"
            >{#if id === 'ripe-ncc-privacy-statement'}Privacy Statement{:else if id === 'cookies'}Cookies{:else if id.includes('terms')}Terms
              of Service{:else}{title}{/if}</span
          ></span
        >

        <span class={open ? 'icon open' : 'icon close'}>
          {#if open}
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fal"
              data-icon="chevron-down"
              class="svg-inline--fa fa-chevron-down fa-w-14"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              ><path
                fill="#757575"
                d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"
              /></svg
            >
          {:else}
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fal"
              data-icon="chevron-down"
              class="svg-inline--fa fa-chevron-down fa-w-14"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              ><path
                fill="#757575"
                d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"
              /></svg
            >
          {/if}
        </span>
      </button>

      {#if subpages}
        <section class:open-panel={open} class="panel">
          {#each Object.values(subpages) as item}
            <button class:active={item.open} class="accordion sub" on:click={() => (item.open = !item.open)}>
              <span class="heading"><span class="button-title sub-title">{item.title}</span></span>
              <span class={item.open ? 'icon open' : 'icon close'}>
                {#if item.open}
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fal"
                    data-icon="chevron-down"
                    class="svg-inline--fa fa-chevron-down fa-w-14"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    ><path
                      fill="#757575"
                      d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"
                    /></svg
                  >
                {:else}
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fal"
                    data-icon="chevron-down"
                    class="svg-inline--fa fa-chevron-down fa-w-14"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    ><path
                      fill="#757575"
                      d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"
                    /></svg
                  >
                {/if}
              </span>
            </button>
            <section class:open-panel={item.open} class="panel subpanel">
              <div class="html-content">
                {#if !item.content.startsWith('<div')}
                  <div>{@html item.content}</div>
                {:else}
                  {@html item.content}
                {/if}
              </div>
            </section>
          {/each}
        </section>
      {:else}
        <section class:open-panel={open} class="panel">
          <div class="html-content">
            {#if !content.startsWith('<div')}
              <div>{@html content}</div>
            {:else}
              {@html content}
            {/if}
          </div>
        </section>
      {/if}
    {/each}
  {:else}
    <em>no data returned from api.</em>
  {/if}
  {#if false}
    <div class="html-content">
      /* eslint-disable a11y-missing-content */
      <div>&nbsp;</div>
      <h1>&nbsp;</h1>
      <h2>&nbsp;</h2>
      <h3>&nbsp;</h3>
      <h4>&nbsp;</h4>
      <table><tr><th>&nbsp;</th></tr><tr><td><p>&nbsp;</p></td></tr></table>
    </div>
  {/if}
</div>

<script>
  /* eslint-disable quotes, object-curly-spacing, quote-props, indent, no-unused-vars, no-tabs, no-mixed-spaces-and-tabs */
  let mydata = []
  export let appname = 'ripe'

  $: appname &&
    (async () => {
      const apiURL = `https://www-static.ripe.net/dynamic/legal-pages/${
        typeof appname === 'undefined' ? 'ripe' : appname
      }-pages.json`
      const res = await fetch(apiURL)
      const json = await res.json()
      for (const x in json) {
        if (json[x].id === 'legal') {
          for (const sub in json[x].subpages) {
            json[x].subpages[sub].open = false
          }
        }
      }
      mydata = Object.values(json).map(val => {
        val.open = false
        return val
      })
    })()
</script>

<style>
  :host {
    font-family: var(--ripe-app-font-family), Helvetica, Verdana, sans-serif;
  }
  .button-title {
    font-family: var(--ripe-app-font-family), Helvetica, Verdana, sans-serif;
    display: inline-block;
    bottom: 7px;
    position: relative;
    padding-left: 20px;
    font-size: 1rem;
  }
  .sub-title {
    padding-left: 54px;
    bottom: 0px;
  }
  .pageinfo {
    padding: 0px 5px 15px 0px;
    width: 100%;
    font-size: 1rem;
    line-height: 1.5;
  }
  .pagetitle {
    font-size: 1.285rem;
    line-height: 1.5;
    font-weight: 500;
  }
  .svgwrap {
    display: inline-block;
    width: 30px;
    margin-left: auto;
    margin-right: auto;
  }
  .svgwrap svg {
    width: 26px;
  }
  .legalstuff {
    margin: 0 auto;
    max-width: 900px;
  }
  .legalstuff svg {
    height: 28px;
  }
  .html-content th {
    text-align: left;
    width: 33%;
  }
  .html-content table {
    border-collapse: collapse;
    margin-top: 10px;
  }
  .html-content td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 10px;
    margin: 0px !important;
    vertical-align: top;
  }
  .html-content td p:first-of-type {
    margin-top: 0;
    padding-top: 0;
  }
  button {
    appearance: none !important;
  }
  button.accordion {
    width: 100%;
    min-height: 48px;
    border-radius: 0 !important;
    padding: 8px 16px 8px 16px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    text-align: left;
    color: #401e12;
    border: 1px solid rgba(0, 0, 0, 0.12);
    cursor: pointer;
    transition: background-color 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
    outline-color: rgba(0, 0, 0, 0.12);
    outline-style: none;
    outline-width: 0px;
    border-bottom-width: 0;
  }
  .sub {
    border: 0 !important;
    border-right: 0 !important;
    border-left: 0 !important;
  }
  button.sub:last-of-type {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
  button.sub.active:last-of-type {
    border-bottom: 0px solid rgba(0, 0, 0, 0.12) !important;
  }
  button.accordion:last-of-type {
    border-bottom-width: 1px;
  }
  button.accordion.active:last-of-type,
  button.accordion.active:last-of-type:hover {
    border-bottom-width: 0px;
  }
  button.accordion:hover {
    background-color: rgba(0, 0, 0, 0.12);
    border-bottom: 0px solid rgba(0, 0, 0, 0.12);
    transition: background-color 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
  button.accordion:last-of-type:hover {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
  button.accordion.active > {
    background-color: rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
  header {
    width: 100%;
    text-align: center;
    color: black;
  }
  .html-content h1,
  .html-content h2,
  .html-content h3,
  .html-content h4 {
    font-size: 1.6rem;
    margin-top: 15px;
    margin-bottom: 10px;
    font-weight: 500;
    line-height: 1.25;
  }
  p {
    padding: 0px 0px 16px 0px;
    margin: auto 0;
  }
  span.icon svg {
    width: 24px;
    height: 24px;
  }
  span.icon {
    font-size: 1.8rem;
    position: relative;
    transition: transform 0.3s;
    transform: rotate3d(0, 0, 1, 0deg);
  }
  span.icon.close {
    transform: rotate3d(0, 0, 1, -90deg);
  }
  span.icon.open > svg {
    transform: rotate3d(0, 0, 1, 0deg);
  }
  section.panel {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    max-height: 0;
    overflow: auto;
    transition: all 0.4s;
  }
  section.panel.subpanel {
    border-right: 0;
    border-left: 0;
  }
  section.open-panel {
    height: auto;
    transition: all 0.4s;
    max-width: 100%;
    max-height: 3000px;
  }
  section.open-panel > {
    max-width: 100%;
  }
  section div button {
    width: 150px;
    font-weight: bold;
    color: white;
    background-color: rgba(0, 0, 0, 0.12);
    padding: 10px 0;
    margin: 10px 10px 20px;
    cursor: pointer;
  }
  div button:active {
    background-color: rgba(0, 0, 0, 0.12);
  }
  .html-content {
    display: block;
    width: 100%;
  }
  .html-content > div {
    display: block;
    max-width: 100%;
  }
  .html-content > div {
    padding-left: 70px;
    padding-right: 30px;
  }
  .html-content > div:first-of-type {
    padding-top: 20px;
  }
  .html-content > div:last-of-type {
    padding-bottom: 30px;
  }
</style>
